import React from "react";
import { motion } from "framer-motion";
import Button from "./UI/Button/Button";
import AnimRegForm from "./Animation/AnimRegForm";

const Registration = () => {
	return (
		<section className="page__registration registration">
			<div className="registration__discount discount">
				<div className="discount__header">
					<img
						src="./img/registration/header.svg"
						className="discount__header-img"
						alt="the top of the frame"
					/>
					<p className="discount__header-title">Repost discount</p>
				</div>

				<div className="discount__body">
					<h2 className="discount__body-title">Cost of participation:</h2>
					<div className="discount__body-price">
						<p className="discount__body-price-current">149$</p>
						<p className="discount__body-price-old">299$</p>
					</div>
					<h3 className="discount__body-text">
						If there is a repost in social networks :)
					</h3>
				</div>

				<div className="discount__footer">
					<p className="discount__footer-text">Get a discount:</p>
					<div className="discount__footer-box">
						<a href="#" className="discount__footer-link">
							<img src="./img/registration/fb.svg" alt="fb icon" />
						</a>
						<a href="#" className="discount__footer-link">
							<img src="./img/registration/insta.svg" alt="instagram icon" />
						</a>
						<a href="#" className="discount__footer-link">
							<img src="./img/registration/twitter.svg" alt="twitter icon" />
						</a>
					</div>
				</div>
			</div>

			<div className="registration__wrapper">
				<h2 className="registration__title">Register to participate</h2>

				<form
					action="#"
					method="post"
					encType="multipart/form-data"
					className="registration__form reg-form"
				>
					<input
						type="text"
						name="username"
						placeholder="Full name children"
						className="reg-form__input"
					/>
					<input
						type="text"
						name="date"
						placeholder="Date of Birth"
						className="reg-form__input"
					/>
					<input
						type="text"
						name="city"
						placeholder="City"
						className="reg-form__input"
					/>
					<input
						type="text"
						name="email"
						placeholder="Email"
						className="reg-form__input"
					/>
					<input
						type="text"
						name="password"
						placeholder="Password"
						className="reg-form__input"
					/>

					<div className="reg-form__check-wrapper">
						<div className="reg-form__check-inner">
							<input
								type="checkbox"
								name="regcheck"
								value="regcheck"
								id="regcheck"
								className="reg-form__check visuallyhidden"
							/>
							<label
								htmlFor="regcheck"
								className="reg-form__check-label"
							></label>
						</div>

						<p className="reg-form__check-text">
							By submitting data I agree with &nbsp;
							<a href="#" className="reg-form__check-link">
								Competition conditions
							</a>{" "}
							<br />и &nbsp;
							<a href="#" className="reg-form__check-link">
								Data Processing Policy
							</a>
						</p>
					</div>

					<div className="reg-form__submit-wrapper">
						<Button
							onClick={(e: any) => e.preventDefault()}
							className="reg-form__submit-button"
						>
							Participate
						</Button>
						<AnimRegForm />
					</div>
				</form>
			</div>
		</section>
	);
};

export default Registration;
